export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Burnt Sugar (Liquid)-64a14ca71b26eb97f55ddc436be84709.pdf";